/** The ship worker's event-wire types; the api `PM_EVENT_TYPES` reads them, so a stored word has one spelling. */
export const DM_SHIP_EVENT_TYPES = { step: 'ship.step', paused: 'ship.paused' };
/** Sortable job-list columns; without one the list keeps queue order. */
export const DM_JOB_SORT_FIELDS = ['created_at', 'updated_at'];
/** Directions for `sort`; `order` without `sort` is refused. */
export const DM_JOB_SORT_ORDERS = ['asc', 'desc'];
/** `order` without `sort` would be accepted and change nothing — every door refuses it. */
export function dmJobOrderHasSort(value) {
    return value.order === undefined || value.sort !== undefined;
}
export const DM_JOB_ORDER_WITHOUT_SORT_REFUSAL = {
    message: 'order needs sort — without sort the list keeps queue order (priority, then oldest)',
    path: ['order'],
};
const DM_JOB_ENQUEUE_KEYS = ['pm.item.create', 'pm.item.link'];
/** The project-settings write pair: `pm.project.update` publishes nothing without the read key. */
const DM_LANE_PROJECT_POLICY_KEYS = ['pm.item.read', 'pm.project.update'];
/**
 * Keys each lane-queue write door charges, in mount order.
 *
 * `autonomy` (merge authority) and `pause` (both directions of the stop switch) charge the
 * settings write pair, so `pm.project.update` alone opens neither. `enqueueWithAutonomy` is
 * what `POST /jobs` owes when its body carries `autonomyMerge`.
 */
export const DM_LANE_DOOR_KEYS = {
    enqueue: DM_JOB_ENQUEUE_KEYS,
    enqueueWithAutonomy: [...DM_JOB_ENQUEUE_KEYS, ...DM_LANE_PROJECT_POLICY_KEYS],
    cancel: ['pm.item.transition'],
    requeue: ['pm.item.transition'],
    autonomy: DM_LANE_PROJECT_POLICY_KEYS,
    pause: DM_LANE_PROJECT_POLICY_KEYS,
};
//# sourceMappingURL=dmJobWire.js.map